import React from "react";
import ColorPicker from "../form-field-editor/ColorPicker";

interface FormTitleAndDescriptionProps {
  title: string;
  description: string;
  backgroundColor?: string;
  onUpdateMeta: (key: "title" | "description" | "bg_color", value: string) => void;
}

const FormTitleAndDescription: React.FC<FormTitleAndDescriptionProps> = ({
  title,
  description,
  backgroundColor,
  onUpdateMeta,
}) => {
  return (
    <div className="border border-gray-200 p-4 rounded-lg">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
        <div className="flex-1">
          <input
            type="text"
            value={title}
            onChange={(e) => onUpdateMeta("title", e.target.value)}
            className="w-full text-2xl font-bold border-none focus:outline-none focus:ring-0"
            placeholder="Formular Titel"
          />
          <input
            type="text"
            value={description || ""}
            onChange={(e) => onUpdateMeta("description", e.target.value)}
            placeholder="Formular Beschreibung"
            className="w-full mt-1 text-gray-600 border-none focus:outline-none focus:ring-0"
          />
        </div>
          <ColorPicker
            selectedColor={backgroundColor}
            onColorSelect={(color) => onUpdateMeta("bg_color", color)}
          />
      </div>
    </div>
  );
};

export default FormTitleAndDescription;
